// 初始化数据
const modals = {
  searchResult: [], //查询结果数据
  searchParams: {},
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  tabList: [{ name: '未签章的对账单' }, { name: '自动签章的对账单' }, { name: '手动签章的对账单' }],
  superClass: 0,
};
export default modals;
